import React, {Fragment} from "react";
import useModalSetup from "../../../../../../hooks/useModalSetup";
import ActionButton from "../../../../../../common/ActionButton";
import CustomFieldModal from "./CustomFieldModal";

export default function CustomFieldEntry({ customFields, filterCustomFieldList, customFieldsInput, handleCustomFields, disabled }) {
    const { handleOpenModal, handleCloseModal, openModal } = useModalSetup();

    const handleCustomFieldFormData = (addedCustomFields) => {
        handleCustomFields(addedCustomFields)
    }

    return(
        <Fragment>
            <ActionButton
                label={'Custom fields'}
                action={handleOpenModal}
                withIcon={false}
                disabled={disabled}
                sx={styles.actionButton}
            />
            <CustomFieldModal
                title={'Custom fields'}
                open={openModal}
                handleClose={handleCloseModal}
                customFields={customFields}
                filterCustomFieldList={filterCustomFieldList}
                customFieldsInput={customFieldsInput}
                handleCustomFieldFormData={handleCustomFieldFormData}
            />
        </Fragment>
    )
}

const styles = {
    actionButton: {
        height: '35px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
}